<script setup lang="ts">
import {RouterView} from "vue-router";

</script>

<template>
  <div class="workspace-outer">
    <RouterView/>
  </div>
</template>

<style scoped>

.workspace-outer {
    position:relative;
    padding: 1.25rem;
}

</style>
